import { IActionFn } from '@/store/types';
import { IModuleState } from './types';
import { $http } from '@/axios';
import store from '@/store';

// 设置客户端背景图片
export const uploadClientBg: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  await $http.post('/v1/baseinfo/operation/setclientbackgroundimg', payload);
  store.commit('common/setToast', { visible: true, text: '设置成功' });
};
